import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { ModelListVM } from '../../api/api-types';

export const actions = createActionGroup({
    source: 'modelsVM',
    events: {
        'Load Model VM List': emptyProps(),
        'Load Model VM List Success': props<{ modelList: ModelListVM }>(),
        'Load Model VM List Failure': props<{ error: string }>(),
    },
});
